import { render, staticRenderFns } from "./PemutakhiranMain.vue?vue&type=template&id=ab52090e&scoped=true&"
import script from "./PemutakhiranMain.vue?vue&type=script&lang=js&"
export * from "./PemutakhiranMain.vue?vue&type=script&lang=js&"
import style0 from "./PemutakhiranMain.vue?vue&type=style&index=0&id=ab52090e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab52090e",
  null
  
)

export default component.exports